export const PROPOSAL_STATUS = {
  PROPOSAL_STATUS_UNSPECIFIED: '0',
  PROPOSAL_STATUS_DEPOSIT_PERIOD: '1',
  PROPOSAL_STATUS_VOTING_PERIOD: '2',
  PROPOSAL_STATUS_PASSED: '3',
  PROPOSAL_STATUS_REJECTED: '4',
  PROPOSAL_STATUS_FAILED: '5',
};

export const VOTE_OPTION = {
  VOTE_OPTION_UNSPECIFIED: '0',
  VOTE_OPTION_YES: '1',
  VOTE_OPTION_ABSTAIN: '2',
  VOTE_OPTION_NO: '3',
  VOTE_OPTION_NO_WITH_VETO: '4',
};
